// React Imports
import type { SVGAttributes } from 'react'

const LayoutCollapsed = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width='104' height='66' viewBox='0 0 104 66' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='104' height='66' rx='4' fill='currentColor' fillOpacity='0.02' />
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H13.7359V66H4C1.79086 66 0 64.2091 0 62V4Z'
        fill='currentColor'
        fillOpacity='0.04'
      />
      <rect
        x='2.94336'
        y='23.8839'
        width='7.84906'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='3.43359' y='5.88135' width='6.86793' height='6.79412' rx='2' fill='currentColor' fillOpacity='0.3' />
      <rect
        x='2.94336'
        y='34.4382'
        width='7.84906'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='2.94336'
        y='44.9923'
        width='7.84906'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect
        x='2.94336'
        y='55.5463'
        width='7.84906'
        height='2.78946'
        rx='1.39473'
        fill='currentColor'
        fillOpacity='0.3'
      />
      <rect x='21.4717' y='4.67169' width='75.437' height='8.8' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='25.6172' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='78.248' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='84.1348' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='90.0215' y='6.87158' width='3.92453' height='4.4' rx='1' fill='currentColor' fillOpacity='0.3' />
      <rect x='50.4912' y='19.6134' width='46.8212' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='21.4717' y='19.6134' width='22.1679' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
      <rect x='21.4717' y='42.4545' width='75.8413' height='17.6' rx='2' fill='currentColor' fillOpacity='0.08' />
    </svg>
  )
}

export default LayoutCollapsed
